// Lower music while characters speak ("ducking"). The same rule is used by the render worker
// (toons-render-worker/src/timeline.js + ffmpeg.js) for the exported video:
//   - a voice = a character's speech, from where its voice block starts on the timeline, for the
//     length of the (trimmed) voice
//   - ducked sounds (background music with "Lower while characters speak", sound layers with the
//     same option) go down to `level` (default 30%) during a voice, fading over DUCK_RAMP seconds.

export const DUCK_RAMP = 0.3;
export const DUCK_LEVEL = 0.3;

/** [[startSec, endSec], ...] of the characters' voices; `offsetPx` is added to timeline positions. */
export function voiceWindows(layers, onePxMs, offsetPx) {
  const out = [];
  if (!Array.isArray(layers) || !(onePxMs > 0)) return out;
  for (const l of layers) {
    if (!l || !l.TTSName || !(Number(l.midTransitionWidths) > 0)) continue;
    const startPx =
      l.LastStartPositionOnTimeline !== undefined && l.LastStartPositionOnTimeline !== null
        ? Number(l.LastStartPositionOnTimeline)
        : Number(l.startPositionOnTimeline) || 0;
    const a = ((startPx + (offsetPx || 0)) * onePxMs) / 1000;
    out.push([a, a + (Number(l.midTransitionWidths) * onePxMs) / 1000]);
  }
  return out;
}

/** Volume factor (level..1) at `sec`. */
export function duckFactor(windows, sec, level) {
  const L = level === undefined || level === null ? DUCK_LEVEL : Math.min(1, Math.max(0, Number(level)));
  let r = 0;
  for (const [a, b] of windows || []) {
    const v = Math.min((sec - (a - DUCK_RAMP)) / DUCK_RAMP, (b + DUCK_RAMP - sec) / DUCK_RAMP);
    if (v > r) r = Math.min(1, v);
  }
  return 1 - (1 - L) * r;
}
